import React, { useRef, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../../_actions";
// import CourseList from "../Teachers/CourseList";

function ProfileOptions(props) {
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);
  const [isVisible, setIsVisible] = useState(true);
  const { user } = useSelector((state) => state.users);
  const options = {
    key: 4,
    label: "Profile",
    submenu: [
      {
        key: 21,
        label: props.label,
        link: props.link,
        icon: "",
        cb: props.handleSelectOption,
      },

      {
        key: 22,
        label: "Profile",
        link: "dashboard/profile",
        icon: "",
        cb: props.handleSelectOption,
      },
      {
        key: 23,
        label: "My Course(s)",
        link: user.role === 1 ? "dashboard/course" : "dashboard/courses",
        icon: "",

        cb: props.handleSelectOption,
      },

      {
        key: 24,
        label: "Security",
        link: "dashboard/profile",
        icon: "",
        cb: props.handleSelectOption,
      },
      {
        key: 25,
        label: "Logout",
        link: "",
        icon: "",
        cb: () => dispatch(userActions.logout()),
      },
    ],
    icon: "",
  };

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setIsVisible(!isVisible);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  return (
    <>
      {isVisible && (
        <div className="forIcons" ref={wrapperRef}>
          {options.submenu ? null : options.label}
          <div className="arrow-up"></div>
          <ul>
            {options.submenu.map((subM) => {
              return (
                <Link
                  to={{ pathname: "/" + subM.link, state: subM.label }}
                  key={subM.key}
                >
                  <li onClick={subM.cb ? subM.cb : null}>
                    <i className={subM.icon} />
                    {subM.label}
                  </li>
                </Link>
              );
            })}
          </ul>
        </div>
      )}
    </>
  );
}

ProfileOptions.propTypes = {
  label: PropTypes.string,
  link: PropTypes.string,
  showOptions: PropTypes.bool,
};

ProfileOptions.defaultProps = {
  label: "Edusity Home",
  link: "",
  showOptions: false,
};

export default ProfileOptions;
